/**
 * Canonical /apps URLs are lowercase and have no trailing slash.
 * Returns the canonical pathname when `pathname` is a non-canonical /apps alias,
 * or null when it is already canonical (or outside the apps section).
 */
export function canonicalAppsPath(pathname) {
  if (!/^\/apps(\/|$)/i.test(pathname)) return null;
  let canonical = pathname.toLowerCase().replace(/\/{2,}/g, '/');
  if (canonical.length > 1) canonical = canonical.replace(/\/+$/, '');
  return canonical === pathname ? null : canonical;
}

export const SITE_ORIGIN = 'https://keval.io';

export const APPS_ROUTES = {
  apps: '/apps',
  birdify: '/apps/birdify',
  birdifyPrivacy: '/apps/birdify/privacy',
  numbcrunch: '/apps/numbcrunch',
  numbcrunchPrivacy: '/apps/numbcrunch/privacy',
  qrCode: '/apps/qr-code',
  qrCodeLicenses: '/apps/qr-code/licenses',
};
